/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/addGroup.config.json";
import notification from "../config/notifications.config.json";
import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { ADD_CREDIT_UNION } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IAddGroupMethods extends IPluginMethodMap {
  getAddGroup(args: any): Promise<any>;
}

export interface IAddGroupMethodsProps {
  name: string;
  description: string;
  logo: any;
  country: string;
  email: string;
}

export class AddGroupService implements IAgentPlugin {
  readonly methods: IAddGroupMethods;

  constructor() {
    this.methods = {
      getAddGroup: this.getAddGroup.bind(this),
    };
  }

  async getAddGroup(args: IAddGroupMethodsProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log(`args inside service`, args);
    try {
      if (client) {
        const res = await client.mutate({
          mutation: ADD_CREDIT_UNION,
          variables: {
            input: {
              ...args,
              logo: args?.logo?.base64,
              role: "CREDIT_UNION",
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.addOrganization,
            notification: notification?.addGroupSuccess,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
